import { SoftwareAddonTemplate } from "../../../lib/model/addonTemplate";
import pacxLogo from "../../images/templates/pacx.png";

export const pacxTemplate: SoftwareAddonTemplate = {
  type: "software",
  id: "pacx",
  title: "PACX",
  platforms: ["msfs", "xplane", "p3d", "fsx"],
  image: pacxLogo,
  content: [
    {
      title: "Simulator Setup",
      roles: ["beforeSimStart", "beforeSimFlightStart", "cockpitPreparation"],
      content: [
        {
          item: "PACX",
          setting: "Started",
        },
      ],
    },
    {
      title: "Before Flight Start",
      roles: ["beforeSimFlightStart", "cockpitPreparation", "beforeFlightStart"],
      content: [
        {
          item: "PACX",
          setting: "Flight Started",
        },
      ],
    },
  ],
};
